import { Link, useParams } from "react-router";
import { Board } from "../components/Board";

/** The AI log arrives in phase 6 (GET /games/{code}/ai-log). */
export function AiLog() {
  const code = (useParams().code ?? "").toUpperCase();
  return (
    <>
      <Board month={12} />
      <main className="stack">
        <h2>Kapteenien lokikirja</h2>
        <p className="muted">Tekoälykapteenien perustelut julkaistaan tässä myöhemmässä versiossa.</p>
        <Link className="btn ghost" to={`/g/${code}`}>
          Takaisin tuloksiin
        </Link>
      </main>
    </>
  );
}
